<template>
  <div
    class="flex flex-1 flex-col items-center justify-center mx-auto w-48 h-full"
  >
    <p class="bg-white text-center pt-2">
      Gunakan eQR Scanner untuk QR di bawah ini.
    </p>
    <div class="flex w-full absolute z-30 justify-center" v-show="!qr.isLoaded">
      <font-awesome-icon :icon="['fas', 'sync']" size="3x" spin />
    </div>
    <div class="shadow-md p-4 relative bg-white" v-show="qr.isLoaded">
      <div
        class="bg-black bg-opacity-75 h-48 w-full top-0 left-0 z-50 absolute"
        v-show="qr.isExpired"
      >
        <div
          class="bg-red-500 text-white bg-opacity-90 p-2 w-full text-center absolute top-32 mt-16"
        >
          QR Expired
        </div>
        <button
          type="button"
          @click="generateQr"
          class="absolute bottom-10 mt-32 ml-5 py-2 items-center justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          <font-awesome-icon :icon="['far', 'eye']" class="mr-2" />Get new QR
          code
        </button>
      </div>
      <div class="relative">
        <img
          v-if="qr.isReady"
          :src="`${qrUrl}/qr_codes/${qr.imageSrc}`"
          @load="(qr.isLoaded = true), $emit('eQrLoaded', qr.code)"
          class="block"
        />
      </div>
    </div>
    <div class="w-48 mt-2 mx-auto row-start-4" v-show="qr.isLoaded">
      <input
        class="block w-full border-0 text-center focus:ring-0 focus:outline-none placeholder:text-black text-black"
        style="background: #eef0f8"
        :placeholder="bypass.text"
        v-model="bypass.code"
        :type="bypass.fieldType"
        v-on:keyup.enter="checkBypass"
        v-on:keyup="bypass.fieldType = 'password'"
        v-on:blur="(bypass.fieldType = 'text'), (bypass.code = bypass.text)"
      />
    </div>
  </div>
</template>

<script>
import { useQR, qr } from "@/services/qr";
const { generateQr, onQrLoad, bypassQr } = useQR();

export default {
  data: () => {
    return {
      qr: qr,
      bypass: {
        text: "Please scan the QR Code",
        code: "Please scan the QR Code",
        fieldType: "text",
      },
      intervalId: null,
    };
  },
  props: {
    oldqr: {},
  },
  computed: {
    qrUrl() {
      return process.env.VUE_APP_QR_URL;
    },
  },
  methods: {
    generateQr,
    onQrLoad,
    bypassQr,
    checkBypass() {
      this.$store.commit("toggleLoading");
      const theBypassCode = this.bypass.code;
      this.$http
        .get(process.env.VUE_APP_API_URL + "/auth/bypass/" + this.bypass.code)
        .then((res) => {
          if (res.data.success === true) {
            bypassQr();
            // Save bpcode in store to pass durign form login]
            this.$emit("saveBypass", theBypassCode);
          }
        })
        .finally(() => {
          this.$store.commit("toggleLoading");
        });
    },
  },
  created() {
    generateQr();
  },
};
</script>
<style lang="scss" scoped>
body {
  @apply overflow-hidden bg-gray-100;

  &.swal2-height-auto.swal2-shown {
    height: 100% !important;
  }
}

#app {
  @apply h-full;
}
</style>
